module.exports = require('./src/index');


//////////////////
// WEBPACK FOOTER
// ./node_modules/my-tools-kit/index.js
// module id = X6Hz
// module chunks = 37